import { useState } from "react";
import * as convert from "../constant/Convert.helper"
import { Row, Col } from "react-bootstrap"

export function ListVoucherCustomer(props) {

  return (
    <div className="order-popup history-credit">
      <div className="popup-cent">
        <div className="content-popup fadeInDown">
          <div className="head-popup">
            <div className="title">
              Danh sách voucher
            </div>
          </div>
          <div className="body-popup">
            <div className="panel-body">
              {props.dataVoucher.length > 0 ?
                <div className="fixed-content-wrapper customer-list-container">
                  <div className="list-voucher-customer">
                    {props.dataVoucher.map((x,y) => {
                      return (
                        <div className="group-voucher" key={y}>
                          <div className="title-group">{x.name}</div>
                          <div className="list-voucher">
                            <Row>
                              {x.listVoucher.map((a,b) => {
                                return (
                                  <Col xs={12} md={4} lg={3} key={b}>
                                    <div className="item-voucher">
                                      <div className="head-voucher">
                                        <div className="code-voucher">{a.code}</div>
                                        <div className="activity-voucher">{a.count_used}/{a.max_used}</div>
                                      </div>
                                      <div className="price-voucher">
                                        {new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(a.amount)}
                                      </div>
                                    </div>
                                  </Col>
                                )
                              })}
                            </Row>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              : "Không có dữ liệu phù hợp"}
            </div>
          </div>
          <div className="bottom-popup">
            <div className="button-container">
              <div className="button-cent style3" onClick={props.onHandelPopup}>
                <span><i className="fas fa-times"></i></span>Đóng
              </div>
            </div>
          </div>
        </div>
        <div onClick={props.onHandelPopup} className="overlay"></div>
      </div>
    </div>
  );
}
